import { isAfter, isBefore, subDays } from "date-fns";
import { TaskStatus } from "shared/constants/task-status";
import { getEffectiveDue } from "shared/get-effective-due";

export const ROW_BG = {
    REDO: "rgba(0, 0, 0, 0.1)",
    OVERDUE: "rgba(255, 204, 204, 0.5)",
    DUE_TODAY: "rgba(255, 255, 204, 0.7)",
    NONE: undefined,
};

export const getRowHighlight = ({ isCompleted, state, dueCentral, now }) => {
    if (isCompleted) {
        return ROW_BG.NONE;
    }

    if (state === TaskStatus.REDO) {
        return ROW_BG.REDO;
    }

    if (!dueCentral || Number.isNaN(dueCentral.getTime())) {
        return ROW_BG.NONE;
    }

    const effectiveDue = getEffectiveDue(dueCentral);

    if (!isAfter(effectiveDue, now)) {
        return ROW_BG.OVERDUE;
    }

    if (!isBefore(now, subDays(effectiveDue, 1))) {
        return ROW_BG.DUE_TODAY;
    }

    return ROW_BG.NONE;
};
